import React, { Component } from 'react'

class AddItem extends Component {
  getMore = () => {
    const { fetchHandler, next } = this.props

    fetchHandler(next)
  }

  render() {
    const { children, data, next, planId, hasNext } = this.props

    return (
      <div>
        {React.cloneElement(children, {
          data,
          next,
          planId,
          loadMoreHandler: this.getMore,
          hasNext
        })}
      </div>
    )
  }
}

export default AddItem



// WEBPACK FOOTER //
// ./src/app/modules/AddItem/index.js